import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import DinamicTable from "../../shared/table";
import BillsStatus from "../../shared/status";
import * as instanceActions from "../../../Redux/api";
import ModalResults from "../../shared/modal/results";
import CheckBox from "../../shared/custom-components/checkbox";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import {
  formatNumber,
  loadingModal,
  formatUTCDate,
  moduleAction,
  infoContainer,
} from "../../utils/functions";
import { getRoles, getSessionCountry } from "../../../Redux/reducer/session";
import { MOD_BILL, EXECUTE, WRITE } from "../../../permissions";
import i18next from "i18next";
import Modal from "../../utils/customModal";
import { withTranslation } from "react-i18next";
import {
  getHolidaysByCountry,
  getisWithinWorkingHours,
} from "../../../Redux/reducer/users";
import { handleWorkingHours } from "../../utils/utilities";
import { getUserHolidayByCountry, workingHoursHandler } from "../../../Redux/actions/userActions";

const defaultModal = { show: false, content: null };

export class TableBillProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: props.sizePerPage,
      provider: props.provider,
      selectedBills: {},
      checkAll: {},
      loading: false,
      showResults: false,
      results: {},
      modal: defaultModal,
    };
  }

  holidayCheckHandler = async (callback) => {
    const { countryCode } = this.props;
    try {
      await this.props.getUserHolidayByCountry(countryCode);

      if (callback) {
        callback();
      }
    } catch (error) {
      this.props.workingHoursHandler({
        isWithinWorkingHours: false,
        holidayStatusOk: false,
      });
    }
  };

  handleAllowedDate = () => {
    const { countryCode, holidaysByCountryCode } = this.props;
    const isWithinWorkingHours = handleWorkingHours(countryCode);

    if (holidaysByCountryCode?.isHoliDay || !isWithinWorkingHours){
      this.props.workingHoursHandler({
        isWithinWorkingHours: false,
        holidayStatusOk: true,
      });
    }

    return holidaysByCountryCode?.isHoliDay || !isWithinWorkingHours;
  };

  getHeaders = () => {
    const { page, checkAll } = this.state;
    const { mode } = this.props;

    let headers = [];

    const id = `checkbox-${page}`;
    const checked = !!checkAll[id];

    if (mode !== "by-status") {
      headers.push({
        grow: 0,
        selector: "checkbox",
        name: (
          <CheckBox
            id={id}
            label=""
            name="checkbox"
            onChange={(e) => this.checkAll(e)}
            checked={checked}
            disabled={!this.props?.isWithinWorkingHours}
          />
        ),
        center: true,
        bodyStyle: { flexGrow: 0 },
        cellFormatter: (row) =>
          this.checkInput(row.item, row.item.observaciones),
      });
    }

    headers.push(
      { selector: "fechaCarga", name: `${i18next.t("bills.table.date")}` },
      {
        selector: "numFactura",
        name: `${i18next.t("bills.table.bill_number")}`,
      },
      { selector: "name", name: `${i18next.t("bills.table.client_name")}` },
      {
        selector: "cedJuridica",
        name: `${i18next.t("bills.table.identification")}`,
      },
      { selector: "reference", name: `${i18next.t("bills.table.reference")}` },
      {
        selector: "fechaEmision",
        name: `${i18next.t("bills.table.creation_date")}`,
      },
      { selector: "monto", name: `${i18next.t("bills.table.ammount")}` },
      {
        selector: "fechaVencimiento",
        name: `${i18next.t("bills.table.expiration_date")}`,
      }
    );

    if (mode !== "draft") {
      headers.push({ selector: "status", name: "Estado" });
    } else {
      headers.push({ selector: "observaciones", name: "Observaciones" });
    }

    return headers;
  };

  checkAll = ({ target: { checked, id } }) => {
    const [, currentPage] = id.split("-");

    const previusData = Object.keys(this.state.selectedBills).reduce(
      (acc, curr) => {
        if (this.state.selectedBills[curr].itemPage !== currentPage)
          acc[curr] = this.state.selectedBills[curr];

        return acc;
      },
      {}
    );

    const newSelected = this.props.data.reduce(
      (
        acc,
        {
          billId,
          toBIllDiscountAddAmount,
          billPayAmount,
          monto,
          currencyDetail: { currencyCode: currency },
        }
      ) => {
        if (!checked) delete acc[billId];
        else {
          acc[billId] = {
            billId,
            billPayAmount: toBIllDiscountAddAmount ? billPayAmount : monto,
            monto,
            currency,
            itemPage: currentPage,
          };
        }
        return acc;
      },
      {}
    );

    const selectedBills = { ...previusData, ...newSelected };

    let checkAll;

    if (checked) checkAll = { ...this.state.checkAll, [id]: id };
    else {
      // eslint-disable-next-line no-unused-vars
      const { [id]: pageId, ...rest } = this.state.checkAll;
      checkAll = rest;
    }
    this.setState({ selectedBills, checkAll });
    if (this.props.updateCreditLine) this.props.updateCreditLine(selectedBills);
  };

  changeSelected = (event) => {
    const { data } = this.props;
    const { selectedBills } = this.state;
    const [selectedId, itemPage] = event.target.id.split("-");

    const {
      billId,
      toBIllDiscountAddAmount,
      billPayAmount,
      monto,
      currencyDetail: { currencyCode: currency },
    } = data.find((bill) => bill.billId === +selectedId);
    let newSelectedList;

    if (event.target.checked) {
      newSelectedList = {
        ...selectedBills,
        [billId]: {
          billId,
          billPayAmount: toBIllDiscountAddAmount ? billPayAmount : monto,
          monto,
          currency,
          itemPage,
        },
      };
    } else {
      // eslint-disable-next-line no-unused-vars
      const { [selectedId]: id, ...restBills } = selectedBills;
      newSelectedList = restBills;
    }

    this.setState({ selectedBills: newSelectedList });
    if (this.props.updateCreditLine) {
      this.props.updateCreditLine(newSelectedList);
    }
  };

  handleTableChange = ({ page, sizePerPage, sort = "", property = "" }) => {
    const { getProviderBills } = this.props;
    var sortFilter =
      property !== "" && property !== null ? `${property},${sort}` : "id,DESC";

    return getProviderBills(
      page,
      sizePerPage,
      this.props.filters,
      sortFilter
    ).then(() => {
      this.setState({ page, sizePerPage });
    });
  };

  checkInput = (item, complete = true) => {
    const { selectedBills } = this.state;

    var billId = `${item.billId}-${this.props.page}`;
    var check = !!selectedBills[item.billId];
    var checkProps = {
      key: billId,
      id: billId,
      label: ``,
      name: billId,
      onChange: (e) => this.changeSelected(e),
      checked: check,
      disabled: !this.props?.isWithinWorkingHours,
    };

    return complete === false ? null : <CheckBox {...checkProps} />;
  };

  resetSelection = () => {
    if (undefined !== this.props.updateCreditLine) {
      this.props.updateCreditLine({});
    }
    this.setState({ selectedBills: {}, checkAll: {} });
  };

  setTableData = () => {
    var { data } = this.props;
    var dataResult = [];

    if (data.length > 0) {
      data.map((item) => {
        var symbol =
          item.currencyDetail !== undefined
            ? item.currencyDetail.currencySymbol
            : "CRC";
        var billObj = {
          fechaCarga: new Date(item.fechaCarga).toLocaleDateString("es-ES"),
          numFactura: (
            <Link to={`/providerSite/bills/${item.billId}/info`}>
              {item.numFactura}
            </Link>
          ),
          name: item.name,
          cedJuridica: item.cedJuridica,
          fechaEmision: formatUTCDate(item.fechaEmision),
          monto: formatNumber(item.monto, symbol),
          fechaVencimiento: formatUTCDate(item.fechaVencimiento),
          reference: item.referenceNumber,
          status: <BillsStatus statusCode={item.status} />,
          observaciones:
            false === item.observaciones ? "Registro incompleto" : "",
          item,
          // checkbox: this.checkInput(item, item.observaciones),
        };

        dataResult.push(billObj);
      });
    }

    return dataResult;
  };

  clearModal = () => {
    this.setState({ modal: defaultModal });
  };

  handleRejectModal = () => {
    const { t, mode } = this.props;

    const action =
      mode === "approved"
        ? () => this.approvedBills(false)
        : this.onRejectBills;
        
        this.setState({
      modal: {
        show: true,
        content: infoContainer(
          t("invoices.approvalsTab.rejectedModal.title"),
          t("invoices.approvalsTab.rejectedModal.description"),
          {
            SelBtn: {
              action: this.clearModal,
              text: t("general.buttons.cancel"),
            },
            formBtn: {
              action: action,
              text: t("general.buttons.rejectedInvoice"),
            },
          }
        ),
      },
    });
  };

  approvedBills = (approved = true) => {
    const { selectedBills } = this.state;
    const {
      instance: { instanceAction },
    } = this.props;
    var bills = [];

    const isNotAllowedDate = this.handleAllowedDate();

    if (isNotAllowedDate) {
      this.resetSelection();
      return;
    }

    this.setState({ loading: true, modal: defaultModal });

    Object.keys(selectedBills).map((key) => {
      return bills.push({
        billId: selectedBills[key].billId,
        status: approved ? this.props.approvedTo : this.props.rejectedTo,
      });
    });

    return instanceAction("/bills/update-status", "put", bills)
      .then((data) => {
        //clear selection
        this.resetSelection();
        this.setState({
          loading: false,
          showResults: true,
          results: data.data.data,
        });
      })
      .catch(() => {
        //clear selection
        this.resetSelection();
        this.setState({ loading: false });
      });
  };

  closeResults = () => {
    this.setState({ showResults: false, results: {} });
    // Data reload
    this.handleTableChange({ page: 0, sizePerPage: this.state.sizePerPage });
  };

  getActions = () => {
    const isApprovedMode = this.props.mode === "approved";
    const billsLength = Object.keys(this.state.selectedBills).length;
    const isProvValid = moduleAction(
      this.props.roles,
      MOD_BILL,
      isApprovedMode ? WRITE : EXECUTE
    );

    var clearProps = { className: `btnLimpiar` };
    clearProps =
      billsLength > 0
        ? {
            ...clearProps,
            onClick: () => this.resetSelection(),
            disabled: !this.props?.isWithinWorkingHours,
          }
        : { ...clearProps, disabled: true };

    var processProps = { className: `btnProcesar` };
    processProps =
      billsLength > 0
        ? {
            ...processProps,
            onClick: () => this.holidayCheckHandler(this.approvedBills),
            disabled: !this.props?.isWithinWorkingHours,
          }
        : { ...processProps, disabled: true };

    var rejectProps = { className: `btnRechazar` };
    rejectProps =
      billsLength > 0
        ? {
            ...rejectProps,
            onClick: () => this.holidayCheckHandler(this.handleRejectModal),
            disabled: !this.props?.isWithinWorkingHours,
          }
        : { ...rejectProps, disabled: true };

    return this.props.needActions ? (
      <div className="form-actions clearfix">
        <SecondaryButton {...clearProps}>Limpiar</SecondaryButton>
        {isApprovedMode && isProvValid && (
          <SecondaryButton {...rejectProps}>Rechazar</SecondaryButton>
        )}

        {this.props.mode === "validated" && isProvValid && (
          <SecondaryButton
            className="btnRechazar"
            onClick={() => this.holidayCheckHandler(this.handleRejectModal)}
            disabled={billsLength === 0}
          >
            Rechazar
          </SecondaryButton>
        )}

        {isProvValid && (
          <SecondaryButton {...processProps}>Aprobar</SecondaryButton>
        )}
      </div>
    ) : null;
  };

  onRejectBills = async () => {
    const { selectedBills } = this.state;
    const {
      instance: { instanceAction },
    } = this.props;

    const bills = Object.keys(this.state.selectedBills).map((key) => ({
      billId: selectedBills[key].billId,
      status: this.props.rejectedTo,
    }));

    this.setState({ loading: true, modal: defaultModal });

    const isNotAllowedDate = this.handleAllowedDate();

    if (isNotAllowedDate) {
      this.setState({ loading: false });
      this.resetSelection();
      return;
    }

    try {
      const response = await instanceAction(
        "/bills/update-status-rejected",
        "put",
        bills
      );
      this.setState({
        loading: false,
        showResults: true,
        results: response.data.data,
      });
    } catch (error) {
      this.setState({ loading: false });
    }
    this.resetSelection();
  };

  render() {
    const { page, sizePerPage, loading, showResults, results, modal } =
      this.state;
    const { totalSize, mode } = this.props;

    const className = showResults ? "" : "table-bill-provider";

    return (
      <div className={className}>
        <DinamicTable
          page={page}
          totalSize={totalSize}
          sizePerPage={sizePerPage}
          data={this.setTableData()}
          headers={this.getHeaders()}
          actions={this.getActions()}
          onTableChange={this.handleTableChange}
          className={mode !== "by-status" ? "checkbox-table" : ""}
        />
        {loading && loadingModal()}
        {showResults && (
          <ModalResults results={results} closeModal={this.closeResults} />
        )}

        {modal.show && <Modal show={modal.show}>{modal.content}</Modal>}
      </div>
    );
  }
}

TableBillProvider.defaultProps = {
  action: null,
  actionlbl: "",
  needActions: true,
};

export const mapStateToProps = (state) => ({
  roles: getRoles(state),
  isWithinWorkingHours: getisWithinWorkingHours(state),
  countryCode: getSessionCountry(state),
  holidaysByCountryCode: getHolidaysByCountry(state),
});

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
    getUserHolidayByCountry: (payload) =>
      dispatch(getUserHolidayByCountry(payload)),
    workingHoursHandler: (payload) => dispatch(workingHoursHandler(payload)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatch)(TableBillProvider)
);
